// extracted by mini-css-extract-plugin
export var actionButton = "_py-0";
export var actionMenuContainer = "_py-i";
export var bubble = "_py-2";
export var bubbleActionMenu = "_py-j";
export var bubbleContext = "_py-6";
export var bubbleItems = "_py-7";
export var customer = "_py-3";
export var divider = "_py-8";
export var fileList = "_py-9";
export var hiddenComment = "_py-o";
export var infoAbove = "_py-a";
export var internal = "_py-4";
export var lightActionButton = "_py-1";
export var link = "_py-b";
export var merchant = "_py-5";
export var message = "_py-c";
export var profilePicture = "_py-e";
export var quillToolbarContainer = "_py-f";
export var senderDate = "_py-g";
export var senderDateCustomer = "_py-h";
export var senderName = "_py-d";
export var time = "_py-k";
export var uploadedImage = "_py-l";
export var username = "_py-m";
export var xsmall = "_py-n";